import script from "./AppNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./AppNavbar.vue?vue&type=style&index=0&id=4e7e13cc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e7e13cc"]])

export default __exports__